import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';
import { CustomInputTextArea } from '../../../../components/CustomInputTextArea';
import { ValidationError } from '../ValidationError';
import { LANGUAGES } from '../../constants';

export const PromotionShortDescription = ({ 
  formData, 
  onInputChange,
  errors = {}
}) => {
  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
          Краткое описание
        </Typography>
        <Grid container spacing={3}>
          {LANGUAGES.map(lang => (
            <Grid item xs={12} md={4} key={lang.value}>
              <Box>
                <CustomInputTextArea
                  placeholder={`Краткое описание (${lang.label})`}
                  value={formData[`short_description_${lang.value}`]}
                  onChange={(e) => onInputChange(`short_description_${lang.value}`, e.target.value)}
                  required
                  fullWidth
                  rows={3}
                  error={!!errors[`short_description_${lang.value}`]}
                />
                <ValidationError error={errors[`short_description_${lang.value}`]} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

PromotionShortDescription.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object
};
